import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, DialogTitle, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { miLegajo } from "../../Redux/legajo";
import { UserAuth } from "../../context/AuthContext";
import TokenContext from "../../context/TokenContext";
import CustomCheckbox from "../CustomCheckbox";
import CustomTextField from "../CustomTextField";

const ModalLicencias = ({ open, handleClose, licencia, onSubmit }) => {
  const token = useContext(TokenContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { empleado } = UserAuth();

  const [aprobacion1, setAprobacion1] = useState("");
  const [validacion1, setValidacion1] = useState("");
  const [validacion3, setValidacion3] = useState("");

  const loadAprobarRechazarLicenciaSelector = useSelector((store) => store.licencias.loadAprobarRechazarLicencia);

  const [idAprobador1, setIdAprobador1] = useState("");
  const [idValidador1, setIdValidador1] = useState("");
  const [idValidadorRRHH, setIdValidadorRRHH] = useState("");

  const validacionSchema = yup.object().shape({
    new_name: yup.string().required("Por favor indica el tipo de Licencia."),
    empleado: yup.string().required("Por favor indica el Empleado."),
    diasSolicitados: yup.string().required("Por favor indica los dias solicitados."),
    new_fechadesdeModal: yup.string().required("Required"),
    new_fechahastaModal: yup.string().required("Required"),
  });

  const defaultValues = {
    id: null,
    licenciaProlongada: false,
    comentarios: "",
    idAprobador1: "",
    aprobacion1: null,
    idValidador1: "",
    validacion1: null,
    idValidadorRRHH: "",
    validacion3: null,
  };

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { handleSubmit, reset } = methods;

  useEffect(() => {
    dispatch(miLegajo(token, empleado.empleadoid));
  }, []);

  useEffect(() => {
      setIdAprobador1(licencia?.idAprobador1);
      setIdValidador1(licencia?.idValidador1);
      setIdValidadorRRHH(licencia?.idValidadorRRHH);
      reset({
        ...licencia,
        aprobacion1: aprobacion1,
        validacion1: validacion1,
        validacion3: validacion3,
      });
  }, [licencia, reset, aprobacion1, validacion1, validacion3]);

  const submitDatos = (datos) => {
    onSubmit(datos);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                name="new_name"
                label="Tipo de Licencia"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el tipo de Licencia."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                name="empleado"
                label="Empleado"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el Empleado."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomCheckbox
                name="licenciaProlongada"
                label="Licencia Prolongada"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                readOnly={true}
                type="number"
                name="diasSolicitados"
                label="Dias Solicitados"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica los dias solicitados."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomTextField
                Component={TextField}
                type="date"
                readOnly={true}
                name="new_fechadesdeModal"
                label="Fecha desde:"
                rules={{ required: "Required!" }}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                type="date"
                readOnly={true}
                name="new_fechahastaModal"
                label="Fecha hasta:"
                rules={{ required: "Required!" }}
              />
            </Grid>
            <Grid xs={12} md={12} item sx={{ pt: 0, pb: 0, mb: 1 }}>
              <CustomTextField
                Component={TextField}
                type="text"
                label="Comentarios"
                name="comentarios"
                multiline={true}
                rows="4"
              />
            </Grid>
            {idAprobador1 === empleado.empleadoid && (
              <>
                <Typography variant="h5">Aprobación y validación</Typography>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                  <CustomTextField
                    Component={TextField}
                    name="nombreAprobador"
                    label="Aprobador 1"
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                      ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection:"column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion1("100000000")}
                        disabled={aprobacion1 === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setAprobacion1("100000001")}
                        disabled={aprobacion1 === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
            {idValidador1 === empleado.empleadoid && (
              <>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                  <CustomTextField
                    Component={TextField}
                    name="nombreValidadorLider"
                    label="Validador Lider"
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                      ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection:"column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setValidacion1("100000000")}
                        disabled={validacion1 === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setValidacion1("100000001")}
                        disabled={validacion1 === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
            {idValidadorRRHH === empleado.empleadoid && (
              <>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 1 }}>
                  <CustomTextField
                    Component={TextField}
                    name="nombreValidadorRRHH"
                    label="Validador Recursos Humanos"
                  />
                </Grid>
                <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                    ¿Que acción desea realizar?
                    </Typography>
                    <Box
                      sx={{
                        minWidth: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setValidacion3("100000000")}
                        disabled={validacion3 === "100000000"}
                        color="success"
                      >
                        Aceptar
                      </Button>
                      <Button
                        sx={{ minWidth: "100%" }}
                        variant="outlined"
                        onClick={() => setValidacion3("100000001")}
                        disabled={validacion3 === "100000001"}
                        color="error"
                      >
                        Rechazar
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={loadAprobarRechazarLicenciaSelector === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ModalLicencias;
